import React from 'react';

import { useTranslation, Trans } from "react-i18next";

import c1 from '../../img/MansoryMesh/c1.webp'
import c2 from '../../img/MansoryMesh/c2.webp'

function MeshSizes () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] mx-[20px] md:mx-[40px] xl:mx-auto">
                <div className="flex items-center justify-center">
                    <p className="text-[28px] xl:text-[45px] open-sans text-[#F26522] text-center leading-[1.4]">
                        <Trans>{t("CompositeMesh.3")}</Trans>
                    </p>
                </div>
                <div className='flex flex-wrap gap-[20px] mt-[30px] md:mt-[65px]'>
                    <div className='w-[500px] flex-grow h-[95px] md:h-[160px] bg-[#272727] flex items-center gap-[15px] px-[15px] md:px-[30px]'>
                        <img src={c1} alt="" className='w-[60px] h-[60px] md:w-[97px] md:h-[97px]'/>
                        <div>
                            <p className='font-[600] open-sans text-[#F26522] text-[14px] md:text-[16px]'>{t('mansorymesh.5')}</p>
                            <p className='text-[#F6F6F6] text-[14px] open-sans md:text-[16px] mt-[15px]'>{t('mansorymesh.6')}</p>
                        </div>
                    </div>
                    <div className='w-[500px] flex-grow h-[95px] md:h-[160px] bg-[#272727] flex items-center gap-[15px] px-[15px] md:px-[30px]'>
                        <img src={c2} alt="" className='w-[60px] h-[60px] md:w-[97px] md:h-[97px]'/>
                        <div>
                            <p className='font-[600] open-sans text-[#F26522] text-[14px] md:text-[16px]'>{t('mansorymesh.7')}</p>
                            <p className='text-[#F6F6F6] text-[14px] open-sans md:text-[16px] mt-[15px]'>{t('mansorymesh.8')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MeshSizes;